import React, { useState } from 'react';
import { func, shape, string } from 'prop-types';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import SidebarPanel from '../../components/SidebarPanel';

import classes from './ManageProfilePageSidebar.module.css';

const ManageProfilePageSidebar = ({ onUpdate, profile, disabled }) => {
    const [nameValue, setNameValue] = useState(profile.name);
    const isNameChanged = nameValue !== profile.name;

    function handleCancel(event) {
        setNameValue(profile.name);
    }

    function handleNameChange(event) {
        setNameValue(event.target.value);
    }

    function handleSubmit(event) {
        event.preventDefault();
        onUpdate({
            ...profile,
            name: nameValue
        });
    }

    return (
        <SidebarPanel
            title="Profile Information"
            titleIconSrc="/assets/images/profilesIconColor.svg"
        >
            <form className={classes.form} onSubmit={handleSubmit}>
                <TextField
                    autoComplete="off"
                    id="name"
                    InputLabelProps={{
                        classes: {
                            root: classes.label
                        }
                    }}
                    InputProps={{
                        classes: {
                            root: classes.input
                        }
                    }}
                    label="Profile Name"
                    onChange={handleNameChange}
                    value={nameValue}
                    disabled={disabled}
                />
                <TextField
                    disabled
                    id="agent-driver"
                    InputLabelProps={{
                        classes: {
                            root: classes.label
                        }
                    }}
                    InputProps={{
                        classes: {
                            root: classes.input
                        }
                    }}
                    label="Agent Driver"
                    value={profile.basType}
                />
                <footer className={classes.footer}>
                    <Button
                        className={classes.button}
                        disabled={!isNameChanged}
                        onClick={handleCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        className={classes.button}
                        color="primary"
                        disabled={!isNameChanged}
                        type="submit"
                        variant="contained"
                    >
                        Update
                    </Button>
                </footer>
            </form>
        </SidebarPanel>
    );
};

ManageProfilePageSidebar.defaultProps = {
    onUpdate: () => {}
};

ManageProfilePageSidebar.propTypes = {
    onUpdate: func,
    profile:  shape({
        basType: string,
        name:    string
    })
};

export default ManageProfilePageSidebar;
